import { useContext } from 'react';
import Input from '@veeva/corgix/input';
import PropTypes from 'prop-types';
import FilterLogicButton from './FilterLogicButton';
import FilterLogicLogs from './FilterLogicLogs';
import FilterSelectionTable from './FilterSelectionTable';
import CustomerStatFilterContext from './CustomerStatFilterContext';
import {
    clearFiltersContainerCSS,
    clearFiltersCSS,
    clearFiltersDisabledCSS,
    filterInputCSS,
    filterInputTopDownCSS,
    filterNameContainerCSS,
    filterNameLabelCSS,
    filterSelectionMenuCSS,
    filterSelectionMenuTopDownCSS,
} from './styles/FilterSelectionDropdownMenuContainer.styles';

export default function FilterSelectionDropdownMenuContainer({
    applicationsWithAvailableStats,
    availableCustomers,
    platformKey,
    mobile,
    topDown,
    allStats,
}) {
    const {
        selectedCustomerFilterList,
        pendingFilterName,
        setPendingFilterName,
        setPendingFilterList,
        setClearFilters,
        setPendingCreateCustomFilterList,
        setPendingCreateCustomFilterQuery,
        setPendingFilterQuery,
        addFilterLogic,
        setAddFilterLogic,
        pendingFilterQuery,
        setCreateCustomFilterName,
        userPreferenceFilters,
        pendingFilterList,
        setNoEmptyRows,
        pendingCreateCustomFilterName,
        errorMsg,
        setErrorMsg,
    } = useContext(CustomerStatFilterContext);

    const handleClearFilters = () => {
        setPendingFilterName('');
        setPendingFilterList([]);
        setPendingFilterQuery('');
        setClearFilters(true);
        setNoEmptyRows(false);
        setErrorMsg('');
        if (selectedCustomerFilterList === 'create_custom') {
            setCreateCustomFilterName('');
            setPendingCreateCustomFilterList([]);
            setPendingCreateCustomFilterQuery('');
        }
    };
    const handleFilterName = (e) => {
        setPendingFilterName(e.target.value);
        if (selectedCustomerFilterList === 'create_custom') {
            setCreateCustomFilterName(e.target.value);
        }
    };

    const getPlaceholderName = () => {
        if (selectedCustomerFilterList === 'create_custom') {
            if (pendingCreateCustomFilterName) {
                return pendingCreateCustomFilterName;
            }
            return 'Enter Name';
        }
        return pendingFilterName;
    };

    if (mobile || topDown) {
        return (
            <div css={filterSelectionMenuTopDownCSS}>
                <div css={filterNameContainerCSS}>
                    <span css={filterNameLabelCSS}>Name</span>
                    <Input
                        required={
                            !(
                                selectedCustomerFilterList === 'create_custom' &&
                                userPreferenceFilters.length === 5
                            )
                        }
                        title="Filter Name"
                        placeholder={getPlaceholderName()}
                        value={
                            selectedCustomerFilterList === 'create_custom'
                                ? pendingCreateCustomFilterName
                                : pendingFilterName
                        }
                        onChange={handleFilterName}
                        css={filterInputTopDownCSS}
                        disabled={
                            selectedCustomerFilterList === 'create_custom' &&
                            userPreferenceFilters.length === 5
                        }
                        readOnly={selectedCustomerFilterList === 'redReport'}
                    />
                </div>
                <div css={clearFiltersContainerCSS}>
                    <button
                        type="button"
                        onClick={handleClearFilters}
                        css={
                            selectedCustomerFilterList === 'redReport' ||
                            pendingFilterList.length === 0
                                ? clearFiltersDisabledCSS
                                : clearFiltersCSS
                        }
                        disabled={
                            selectedCustomerFilterList === 'redReport' ||
                            pendingFilterList.length === 0
                        }
                    >
                        Clear Filters
                    </button>
                </div>
                <FilterSelectionTable
                    applications={applicationsWithAvailableStats}
                    customers={availableCustomers}
                    platformKey={platformKey}
                    topDown={topDown}
                    mobile={mobile}
                    allStats={allStats}
                />
                {selectedCustomerFilterList === 'redReport' ? null : (
                    <FilterLogicButton
                        addFilterLogic={addFilterLogic}
                        setAddFilterLogic={setAddFilterLogic}
                        pendingFilterQuery={pendingFilterQuery}
                        setPendingFilterQuery={setPendingFilterQuery}
                        setPendingCreateCustomFilterQuery={setPendingCreateCustomFilterQuery}
                        pendingFilterList={pendingFilterList}
                        error={errorMsg !== ''}
                        setErrorMsg={setErrorMsg}
                        selectedCustomerFilterList={selectedCustomerFilterList}
                    />
                )}
                {errorMsg === '' ? null : <FilterLogicLogs errorMsg={errorMsg} />}
            </div>
        );
    }
    return (
        <div css={filterSelectionMenuCSS}>
            <div css={filterNameContainerCSS}>
                <span css={filterNameLabelCSS}>Name</span>
                <Input
                    required={
                        !(
                            selectedCustomerFilterList === 'create_custom' &&
                            userPreferenceFilters.length === 5
                        )
                    }
                    title="Filter Name"
                    placeholder={getPlaceholderName()}
                    value={
                        selectedCustomerFilterList === 'create_custom'
                            ? pendingCreateCustomFilterName
                            : pendingFilterName
                    }
                    onChange={handleFilterName}
                    css={filterInputCSS}
                    disabled={
                        selectedCustomerFilterList === 'create_custom' &&
                        userPreferenceFilters.length === 5
                    }
                    readOnly={selectedCustomerFilterList === 'redReport'}
                />
            </div>
            <div css={clearFiltersContainerCSS}>
                <button
                    type="button"
                    onClick={handleClearFilters}
                    css={
                        selectedCustomerFilterList === 'redReport' || pendingFilterList.length === 0
                            ? clearFiltersDisabledCSS
                            : clearFiltersCSS
                    }
                    disabled={
                        selectedCustomerFilterList === 'redReport' || pendingFilterList.length === 0
                    }
                >
                    Clear Filters
                </button>
            </div>
            <FilterSelectionTable
                applications={applicationsWithAvailableStats}
                customers={availableCustomers}
                platformKey={platformKey}
                topDown={mobile}
                allStats={allStats}
            />
            {selectedCustomerFilterList === 'redReport' ? null : (
                <FilterLogicButton
                    addFilterLogic={addFilterLogic}
                    setAddFilterLogic={setAddFilterLogic}
                    pendingFilterQuery={pendingFilterQuery}
                    setPendingFilterQuery={setPendingFilterQuery}
                    setPendingCreateCustomFilterQuery={setPendingCreateCustomFilterQuery}
                    pendingFilterList={pendingFilterList}
                    error={errorMsg !== ''}
                    setErrorMsg={setErrorMsg}
                />
            )}
            {errorMsg === '' ? null : <FilterLogicLogs errorMsg={errorMsg} />}
        </div>
    );
}

FilterSelectionDropdownMenuContainer.propTypes = {
    allStats: PropTypes.arrayOf(
        PropTypes.shape({
            compoundKey: PropTypes.string,
            label: PropTypes.string,
            statKey: PropTypes.string,
            type: PropTypes.string,
        }),
    ),
    applicationsWithAvailableStats: PropTypes.arrayOf(
        PropTypes.shape({
            key: PropTypes.string,
            label: PropTypes.string,
            stats: PropTypes.arrayOf(
                PropTypes.shape({
                    applicationKey: PropTypes.string,
                    key: PropTypes.string,
                    label: PropTypes.string,
                }),
            ),
        }),
    ),
    availableCustomers: PropTypes.arrayOf(
        PropTypes.shape({
            id: PropTypes.string,
            label: PropTypes.string,
        }),
    ),
    mobile: PropTypes.bool,
    platformKey: PropTypes.string,
    topDown: PropTypes.bool,
};
